import { render, staticRenderFns } from "./LiquidationForm.vue?vue&type=template&id=52ebdebc&scoped=true&"
import script from "./LiquidationForm.vue?vue&type=script&lang=js&"
export * from "./LiquidationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ebdebc",
  null
  
)

export default component.exports